import { render, staticRenderFns } from "./MinusButton.vue?vue&type=template&id=40ec441e&scoped=true"
import script from "./MinusButton.vue?vue&type=script&lang=js"
export * from "./MinusButton.vue?vue&type=script&lang=js"
import style0 from "./MinusButton.vue?vue&type=style&index=0&id=40ec441e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec441e",
  null
  
)

export default component.exports